import { defaultLocale, supportedLocales } from '@/shared/i18n/config';

export function getPathLocale(pathname: string): string | undefined {
	const [, firstSegment] = pathname.split('/');
	return (supportedLocales as readonly string[]).includes(firstSegment) ? firstSegment : undefined;
}

export function splitLocale(pathname: string): { locale: string; pathname: string } {
	const [, firstSegment, ...rest] = pathname.split('/');
	if (getPathLocale(pathname)) {
		return { locale: firstSegment, pathname: `/${rest.join('/')}` || '/' };
	}

	return { locale: defaultLocale, pathname };
}

export function localizePathname(pathname: string, locale: string): string {
	const normalizedPathname = splitLocale(pathname).pathname;
	const prefix = locale !== defaultLocale ? `/${locale}` : '';

	return `${prefix}${normalizedPathname}`;
}

export function applyPreferredLocale(pathname: string, preferredLocale: string): string {
	if (getPathLocale(pathname) || !(supportedLocales as readonly string[]).includes(preferredLocale)) return pathname;

	return localizePathname(pathname, preferredLocale);
}
